import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { EndPointProvider } from './endPointProvider';


@Injectable({
  providedIn: 'root'
})
export class SalesService  {

  constructor(private http: HttpClient,private endPointProvider:EndPointProvider) { }

  getSales(from: Date, to: Date, supplier: string, category: string, skip: number, limit: number, sortField: string, isDecending: boolean) {
    return this.http.get<any>(`${this.endPointProvider.serviceApi}/sales/?from=${from.toISOString()}&to=${to.toISOString()}&category=${category}&supplier=${supplier}` +
      `&skip=${skip}&limit=${limit}&sortField=${sortField}&isDecending=${isDecending}`);
  }
  getRecentSales(count: number) {
    return this.http.get<any>(`${this.endPointProvider.serviceApi}/sales/recent/?count=${count}`);
  }

  getSalesOrders(from: Date, to: Date, skip: number, limit: number) {
    return this.http.get<any>(`${environment.serviceApi}/sales/orders/?from=${from.toISOString()}&to=${to.toISOString()}` +
      `&skip=${skip}&limit=${limit}`);
  }
  updateDeliveryStatus(from: Date, to: Date) {
    return this.http.post<any>(`${environment.serviceApi}/sales/updatedeliverystatus/?from=${from.toISOString()}&to=${to.toISOString()}`, null);
  }
  getSalesInbox(from: Date, to: Date, supplier: string, classId: string, skip: number, limit: number, sortField: string, isDecending: boolean) {
    return this.http.get<any>(`${environment.serviceApi}/sales/inbox/?from=${from.toISOString()}&to=${to.toISOString()}&classId=${classId}&supplier=${supplier}` +
      `&skip=${skip}&limit=${limit}&sortField=${sortField}&isDecending=${isDecending}`);
  }
  getSalesFigure(from: Date, to: Date, useNetProfit: boolean) {
    return this.http.get<any>(`${environment.serviceApi}/sales/salesfigures?from=${from.toISOString()}&to=${to.toISOString()}&useNetProfit=${useNetProfit}`);
  }
  getSalesFigureOnly(from: Date, to: Date, useNetProfit: boolean) {
    // if (!!showDummy) {
    //   return this.http.get<any>(`${environment.serviceApi}/dummysalesdata/salesfiguresonly`);
    // } else {
      return this.http.get<any>(`${this.endPointProvider.serviceApi}/sales/salesfiguresonly?from=${from.toISOString()}&to=${to.toISOString()}&useNetProfit=${useNetProfit}`);
   // }
  }
  getTopProfitables(from: Date, to: Date, count: number, useNetProfit: boolean,reverseOrder:boolean=false) {
    // if (!!showDummy) {
    //   return this.http.get<any>(`${environment.serviceApi}/dummysalesdata/topprofititems`);
    // } else {
      return this.http.get<any>(`${this.endPointProvider.serviceApi}/sales/topprofititems?from=${from.toISOString()}&to=${to.toISOString()}&count=${count}&useNetProfit=${useNetProfit}&reverseOrder=${reverseOrder}`);
    //}
  }
   getTopSellables(from: Date, to: Date, count: number, useNetProfit: boolean, reverseOrder: boolean = false) {
    // if (!!showDummy) {
    //   return this.http.get<any>(`${environment.serviceApi}/dummysalesdata/topprofititems`);
    // } else {
      return this.http.get<any>(`${this.endPointProvider.serviceApi}/sales/topsellingititems?from=${from.toISOString()}&to=${to.toISOString()}&count=${count}&useNetProfit=${useNetProfit}&reverseOrder=${reverseOrder}`);
    //}
  }

  getSalesSummary(from: Date, to: Date, storefronts: string[], skip: number, limit: number, sortField: string, isDecending: boolean) {
    return this.http.get<any>(`${this.endPointProvider.serviceApi}/sales/summary?from=${from.toISOString()}&to=${to.toISOString()}&storefronts=${storefronts.toString()}` +
      `&skip=${skip}&limit=${limit}&sortField=${sortField}&isDecending=${isDecending}`);
  }
  getSalesDetails(itemId: string, from: Date, to: Date) {
    return this.http.get<any[]>(`${environment.serviceApi}/sales/details?itemId=${itemId}&from=${from.toISOString()}&to=${to.toISOString()}`);
  }

  downloadSales(from: Date, to: Date, selectedSupplier: string, selectedCategory: string, selectedView: number) {
    return this.http.get(`${environment.serviceApi}/sales/downloadcsv/?from=${from.toISOString()}&to=${to.toISOString()}&category=${selectedCategory}&supplier=${selectedSupplier}&view=${selectedView}`,
      { responseType: 'arraybuffer' });

  }
}
